"use client"
import usePrivacyPolicyLink from "@/lib/hooks/usePrivacyPolicyLink"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { StyledSvgIcon } from "../shared/shared"

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  background: var(--Direct-White, #ffffff);
  padding: 30px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 13px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: flex-start;
    gap: 20px;
    padding: 20px;
  }
`

const StyledCloseButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`

const StyledContentContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: flex-start;
    gap: 8px;
  }
`

const StyledContent = styled(Typography)`
  color: var(--Black, #1f1f1f);
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 26px;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 14px;
    line-height: 24px;
  }
`

const CookieBanner = (): React.ReactElement | null => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const hasBeenDismissed = localStorage.getItem("cookieBannerDismissed")
    if (!hasBeenDismissed) {
      setIsVisible(true)
    }
  }, [])

  const handleDismiss = (): void => {
    setIsVisible(false)
    localStorage.setItem("cookieBannerDismissed", "true")
    // Set expiration for 6 months (in milliseconds)
    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() + 30 * 6)
    localStorage.setItem("cookieBannerDismissedExpiry", expirationDate.toISOString())
  }
  const privacyPolicyLink = usePrivacyPolicyLink()
  const text = `האתר עושה שימוש בעוגיות כדי לשפר את חוויית הגלישה שלך, להציג תכנים מותאמים אישית ועוד. למידע נוסף אנא קראו את מדיניות הפרטיות שלנו.`
  const textWithLink = text.replace(
    "מדיניות הפרטיות",
    `<a href="${privacyPolicyLink}" target="_blank" style="color:inherit; text-decoration:underline;">מדיניות הפרטיות</a>`,
  )

  if (isVisible) {
    return (
      <StyledContainer>
        <StyledContentContainer>
          <StyledSvgIcon src="/assets/cookie-icon.svg" w={40} h={40} style={{ minWidth: "40px" }} />
          <StyledContent dangerouslySetInnerHTML={{ __html: textWithLink }} />
        </StyledContentContainer>
        <StyledCloseButton onClick={handleDismiss}>
          <StyledSvgIcon src="/assets/XIcon.svg" alt="close" w={24} h={24} />
        </StyledCloseButton>
      </StyledContainer>
    )
  } else {
    return null
  }
}
export default CookieBanner
